module.exports = __webpack_public_path__ + "img/cont_a.144a467d.png";